import { render, staticRenderFns } from "./BctConcept.vue?vue&type=template&id=0031f8d4&scoped=true&lang=pug&"
import script from "./BctConcept.vue?vue&type=script&lang=js&"
export * from "./BctConcept.vue?vue&type=script&lang=js&"
import style0 from "./BctConcept.vue?vue&type=style&index=0&id=0031f8d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031f8d4",
  null
  
)

export default component.exports